<template>
  <div class="Settings">
    <ld-header>
      注销账号
    </ld-header>
    <!-- 注销 -->
    <div v-show="tabs==1">
      <van-cell-group>
        <van-cell>
          账号注销后，将放弃以下权益和资产
        </van-cell>
        <van-cell>
          1.历史订单将无法查询
        </van-cell>
        <van-cell>
          2.账号将会无法登录
        </van-cell>
        <van-cell>
          3.不再收到{{ loginConfig.pageName }}的相关营销信息
        </van-cell>
        <van-cell>
          4.放弃积分和优惠券等权益
        </van-cell>
      </van-cell-group>
      <div class="quit_btn">
        <ld-button
          main
          round
          @click="account()"
        >
          注销
        </ld-button>
      </div>
    </div>
    <!-- 注销成功 -->
    <div v-show="tabs==2">
      <van-cell-group>
        <van-cell>
          账号注销成功
        </van-cell>
        <van-cell>
          1.您的身份、账户信息已清空
        </van-cell>
        <van-cell>
          2.会员权益已清空
        </van-cell>
        <van-cell>
          3.交易记录将清空且无法恢复
        </van-cell>
        <van-cell>
          4.账号将会无法登录
        </van-cell>
      </van-cell-group>
      <div class="quit_btn">
        <ld-button
          main
          round
          @click="login_out()"
        >
          退出
        </ld-button>
      </div>
    </div>
    <!-- 注销失败 -->
    <div v-show="tabs==3">
      <van-cell-group>
        <van-cell>
          抱歉，账号无法注销
          <div class="gray font12">
            由于以下原因，导致账号无法注销
          </div>
        </van-cell>
        <van-cell>
          您还存在未支付的订单，请先完成支付后再申请账号注销。
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ldHeader from 'Common/ldHeader'
import ldButton from 'Common/ldButton'
import { Cell , CellGroup  } from 'vant'
import { getDeviceInfo } from 'CommonUtils/plus.js'

export default {
  name:'Setting',
  components: {
    ldHeader,
    ldButton,
    [CellGroup.name]:CellGroup,
    [Cell.name]:Cell,
  },
  data () {
    return {
      tabs:1,
    }
  },
  methods: {
    account(){
      this.$dialog.confirm({
        title:'提示',
        message:'确认注销当前账号？'
      }).then(()=>{
        let deviceInfo=getDeviceInfo()
        this.$api['user/vipCancel']({
          'deviceId': deviceInfo.uuid||'',
          'deviceShortname':deviceInfo.companyVendor?(deviceInfo.companyVendor+'-'+deviceInfo.phoneModel):''
        }).then(res=>{
          var cache=res.data||{}
          if(cache.success==1){//成功
            this.tabs=2
          }else{
            this.tabs=3
          }
        }).catch(()=>{

        })
      })
    },
    login_out(){
      this.$router.push('/login')
    }
  },
  computed: {
    ...mapGetters(['userInfo','loginConfig'])
  }
}
</script>

<style lang="less">
.Settings {

  .quit_btn {
    position: fixed;
    width: 100%;
    bottom: .52rem;
    padding: 0 .74rem;
  }
}
</style>


